"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transactions = void 0;
const gearbox_1 = require("@busy-human/gearbox");
var Transactions;
(function (Transactions) {
    let SystemTransactionTargetId;
    (function (SystemTransactionTargetId) {
        SystemTransactionTargetId["operating"] = "operating";
        SystemTransactionTargetId["trust"] = "trust";
    })(SystemTransactionTargetId = Transactions.SystemTransactionTargetId || (Transactions.SystemTransactionTargetId = {}));
    let TransactionTargetType;
    (function (TransactionTargetType) {
        /** Unknown, AVOID */
        TransactionTargetType["unknown"] = "unknown";
        /** A payment received from a card or other external account */
        TransactionTargetType["payment"] = "payment";
        /** A payment that affects the Opt & Stripe Account balance of a user */
        TransactionTargetType["stripe_account"] = "stripe_account";
        /** A payout to a debit card or bank account */
        TransactionTargetType["external_account"] = "external_account";
        /** A transfer to a system account */
        TransactionTargetType["system"] = "system";
        /** Fees collected by Stripe */
        TransactionTargetType["stripe_fees"] = "stripe_fees";
        /** A split portion of a transaction */
        TransactionTargetType["transaction"] = "transaction";
    })(TransactionTargetType = Transactions.TransactionTargetType || (Transactions.TransactionTargetType = {}));
    let TransactionType;
    (function (TransactionType) {
        /** Transferring an amount to/from a user to cover Stripe fees; A transfer is money movement WITHIN the Stripe system */
        TransactionType["feeTransfer"] = "feeTransfer";
        /** Transferring an amount to/from a user of their earnings; A transfer is money movement WITHIN the Stripe system */
        TransactionType["earningsTransfer"] = "earningsTransfer";
        /** Transferring an amount to/from a user of excess fees given to user; A transfer is money movement WITHIN the Stripe system */
        TransactionType["excessFeeReturnTransfer"] = "excessFeeReturnTransfer";
        /** Waive excess fees owed to Opt (likely only an issue in dev??) */
        TransactionType["waiveFeesOwed"] = "waiveFeesOwed";
        /** A payment is money paid for meetings */
        TransactionType["payment"] = "payment";
        /** A fee is money paid to Opt & Stripe for using the platform */
        TransactionType["fee"] = "fee";
        /** A payout is the moving money to OUTSIDE of the Stripe platform */
        TransactionType["payout"] = "payout";
        /** A deposit is money ADDED by a party into the Stripe platform */
        TransactionType["deposit"] = "deposit";
        /**
         * ADMIN TRANSACTIONS
         * */
        /** A credit is money credited to a user from Opt through the admin portal */
        TransactionType["credit"] = "credit";
        /** A refund is money refunded to a user from Opt through the admin portal (essentially the same as credit)*/
        TransactionType["refund"] = "refund";
        /** A adjustment is money taken from a user by Opt through the admin portal*/
        TransactionType["adjustment"] = "adjustment";
    })(TransactionType = Transactions.TransactionType || (Transactions.TransactionType = {}));
    let TransactionTargetScopeType;
    (function (TransactionTargetScopeType) {
        /** A user id within the Opt Firebase */
        TransactionTargetScopeType["optUserId"] = "optUserId";
        /** A stripe customer ID */
        TransactionTargetScopeType["stripeCustomerId"] = "stripeCustomerId";
        /** A stripe account ID */
        TransactionTargetScopeType["stripeAccountId"] = "stripeAccountId";
    })(TransactionTargetScopeType = Transactions.TransactionTargetScopeType || (Transactions.TransactionTargetScopeType = {}));
    let TransactionStatus;
    (function (TransactionStatus) {
        /** Transaction is just a data structure, no action taken */
        TransactionStatus["draft"] = "draft";
        /** Transaction has been authorized */
        TransactionStatus["authorized"] = "authorized";
        /** Transaction is in an authorization/with payment hold state */
        TransactionStatus["hold"] = "hold";
        /** Transaction has been "created" or "submitted" and is currently processing */
        TransactionStatus["pending"] = "pending";
        /** Transaction appears on the corresponding account but the funds are in-transit */
        TransactionStatus["posted"] = "posted";
        /** Payments Only: Available means the transaction is in Opt's Stripe account */
        TransactionStatus["available"] = "available";
        /** For payments, the money is available to withdraw; for all others it means the money is finished processing */
        TransactionStatus["complete"] = "complete";
        /** Transaction had a problem or failed to process */
        TransactionStatus["failed"] = "failed";
        /** Transaction has cancelled by the user */
        TransactionStatus["canceled"] = "canceled";
        /** Transaction has gone unconfirmed by both users for over 96 hours */
        TransactionStatus["credited"] = "credited";
    })(TransactionStatus = Transactions.TransactionStatus || (Transactions.TransactionStatus = {}));
    function basicDefault() {
        return {
            amount: 0,
            gross: 0,
            fees: 0,
            currency: "usd",
            status: TransactionStatus.draft,
            source: {
                type: null,
                scopeType: null,
                id: null
            },
            target: {
                type: null,
                scopeType: null,
                id: null
            },
            error: null,
            userIds: [],
            type: null,
            createdAt: new Date().toISOString(),
            availableDate: null,
            meetingId: null,
            inviteId: null,
        };
    }
    function DefaultEarningsTransfer() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.earningsTransfer, status: TransactionStatus.draft, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            }, triggerTransactionOnSubmit: null });
        return tmp;
    }
    Transactions.DefaultEarningsTransfer = DefaultEarningsTransfer;
    function DefaultFeeTransfer() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.feeTransfer, status: TransactionStatus.draft, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            }, triggerTransactionOnSubmit: null });
        return tmp;
    }
    Transactions.DefaultFeeTransfer = DefaultFeeTransfer;
    function DefaultExcessFeeReturnTransfer() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.excessFeeReturnTransfer, status: TransactionStatus.draft, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            }, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultExcessFeeReturnTransfer = DefaultExcessFeeReturnTransfer;
    function DefaultWaiveFeesOwedTransaction() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.waiveFeesOwed, status: TransactionStatus.draft, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            }, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultWaiveFeesOwedTransaction = DefaultWaiveFeesOwedTransaction;
    function DefaultDeposit() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.deposit });
        return tmp;
    }
    Transactions.DefaultDeposit = DefaultDeposit;
    function DefaultPayout() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.payout, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.external_account,
                scopeType: TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultPayout = DefaultPayout;
    function DefaultFee() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.fee, meetingRequest: '', status: TransactionStatus.draft });
        return tmp;
    }
    Transactions.DefaultFee = DefaultFee;
    function DefaultPayment() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.payment, paymentIntentId: null, paymentMethodPath: null, source: {
                type: TransactionTargetType.payment,
                scopeType: TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.system,
                scopeType: TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultPayment = DefaultPayment;
    function DefaultCreditTransfer() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.credit, status: TransactionStatus.draft, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultCreditTransfer = DefaultCreditTransfer;
    function DefaultRefundTransfer() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.refund, status: TransactionStatus.draft, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultRefundTransfer = DefaultRefundTransfer;
    function DefaultAdjustment() {
        const tmp = Object.assign(Object.assign({}, basicDefault()), { type: TransactionType.adjustment, status: TransactionStatus.draft, source: {
                type: TransactionTargetType.stripe_account,
                scopeType: Transactions.TransactionTargetScopeType.optUserId,
                scope: null,
                id: null
            }, target: {
                type: TransactionTargetType.stripe_account,
                scopeType: null,
                scope: null,
                id: null
            } });
        return tmp;
    }
    Transactions.DefaultAdjustment = DefaultAdjustment;
    function isTransfer(dataOrType) {
        let type;
        if (typeof dataOrType === "string") {
            type = dataOrType;
        }
        else {
            type = dataOrType.type;
        }
        return type === TransactionType.feeTransfer || type === TransactionType.earningsTransfer || type === TransactionType.excessFeeReturnTransfer;
    }
    Transactions.isTransfer = isTransfer;
    class CollectionClass extends gearbox_1.CollectionEntity {
        defaults() {
            return DefaultDeposit();
        }
    }
    Transactions.CollectionClass = CollectionClass;
    Transactions.Collection = new CollectionClass({ path: "/Transactions" });
})(Transactions = exports.Transactions || (exports.Transactions = {}));
//# sourceMappingURL=index.js.map